module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_0@2x.a88e801f.png";